import { type Element } from 'slate';

import { InfoBlockComponent } from './components/InfoBlockComponent';
import BlockFormatPluginFactory from '../Blocks/BlockFormatPluginFactory';
import tools from '../../tools';
import type { InfoBlockType, EditorPlugin } from '../../types/aha-editor';

// The allowed types of info blocks.
export const infoBlockTypes: InfoBlockType[] = [
  'infoBlock',
  'noteBlock',
  'warningBlock',
  'tipBlock',
];

// React component for rendering an info block. Also used by the serializer.

// Common configuration for each type of info block.
const InfoBlockComponentPluginFactory = (
  type: Element['type'],
  title: string
): EditorPlugin[] => [
  BlockFormatPluginFactory({
    type,
    tag: type,
    title,
    isMultiline: false,
    allowTab: true,
    exitOnBackspace: true,
    clearFormattingAtEnd: true,
    internalSoftBreak: true,
  }),
  {
    id: type,
    name: `${title} component plugin`,
    components: [
      {
        type,
        component: InfoBlockComponent,
        toolbarItems: [
          [
            tools.ToolInfoBlockTypeInfo,
            tools.ToolInfoBlockTypeNote,
            tools.ToolInfoBlockTypeWarning,
            tools.ToolInfoBlockTypeTip,
          ],
        ],
      },
    ],
  },
];

export default InfoBlockComponentPluginFactory;
